import { InjectionToken } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';

export interface LazyMapsAPIConfig {
    apiKey?: string;
}

export const MAPS_API_CONFIG: InjectionToken<LazyMapsAPIConfig> =
    new InjectionToken('LazyMapsAPIConfig');

export const MAP_API_LOADER: InjectionToken<Loader> = new InjectionToken(
    'Google Maps Api Loader',
);
